module.exports = __webpack_public_path__ + "img/sfdw.8cad769a.png";